import React, { useState, ChangeEvent, DragEvent } from 'react';
import logo from "../../asset/EssilorLuxottica.svg";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BASE_API } from '../TableAPI/Constant';
import { Box, Flex, Image, Button, Textarea, Text, Input, Stack, Button as ChakraButton } from '@chakra-ui/react';
import ClockBar from '../Search/ClockBar';
import { useNavigate } from 'react-router-dom';


const Upload = () => {
    const navigate = useNavigate();
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
    const [url, setUrl] = useState<string[]>([]);
    const [files, setFiles] = useState<File[]>([]);
    const [inputType, setInputType] = useState<string>('file');
    const [password, setPassword] = useState<string>('');
    const [isPasswordEnabled, setIsPasswordEnabled] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');

    const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        const inputValue: string = event.target.value;
        const urlsArray: string[] = inputValue.split('\n');
        setUrl(urlsArray);
        setIsPasswordEnabled(true);
    };

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const uploadedFiles = event.target.files;
        if (uploadedFiles) {
            setFiles((prevFiles) => [...prevFiles, ...Array.from(uploadedFiles)]);
        }
        setIsPasswordEnabled(false);
    };

    const handleButtonClick = async (type: string): Promise<void> => {
        setInputType(type);
        setUrl([]);
        setFiles([]);
        setPassword('');
        setIsPasswordEnabled(type === 'url');
        setErrorMessage('');
    };

    const handleDrop = (event: DragEvent<HTMLDivElement>): void => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles) {
            setFiles((prevFiles) => [...prevFiles, ...Array.from(droppedFiles)]);
        }
        setIsPasswordEnabled(false);
    };

    const handleRemoveFile = (index: number): void => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handleApply = async () => {
        setIsLoading(true);
        setErrorMessage('');

        const mainProjectId = sessionStorage.getItem('mainProjectId') || '';
        const formData = new FormData();
        formData.append('main_project_id', mainProjectId);
        formData.append('columns_to_extract', JSON.stringify(selectedOptions));
        files.forEach((file, index) => {
            formData.append('file', file);
        });

        try {
            if (inputType === 'file' && files.length > 0) {
                const response1 = await axios.post(
                    `${BASE_API}/cofProjects/loadProjectsBackground/`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );
                checkUploadStatus(response1.data.uploadId, 'file');
                console.log('Response 1:', response1.data, 'main_project_id: ', mainProjectId, 'columns_to_extract', JSON.stringify(selectedOptions));
            }

            if (inputType === 'url' && isPasswordEnabled && password === 'LuxotticaMassDL#1234') {
                const urlsString = url.join(",").split(",");
                const response2 = await axios.post(`${BASE_API}/cofProjects/loadByUrlBackground/`, {
                    "urls": urlsString,
                    "main_project_id": mainProjectId,
                    "lux_pass": password,
                    "column_to_extract": selectedOptions
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                checkUploadStatus(response2.data.uploadId, 'url');
                if (response2.data.error) {
                    setErrorMessage('One or more URLs point to non-existent files. Please check and try again.');
                }

                console.log('Response 2:', response2.data, 'main_project_id: ', mainProjectId, "urls: ", urlsString);
            }
        } catch (error) {
            if (axios.isAxiosError(error)) {
                console.error('Axios error:', error.response);
                setErrorMessage(`Error: ${error.response?.status} - ${error.response?.statusText}`);
            } else {
                console.error('Unexpected error:', error);
                setErrorMessage('An unexpected error occurred. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const checkUploadStatus = async (uploadId: string, type: string) => {
        try {
            const response = await axios.get(`${BASE_API}/cofProjects/statusUpload/${uploadId}`);
            if (response.data.status === 'DONE') {
                console.log('Upload completato');
            } else {
                setTimeout(() => checkUploadStatus(uploadId, type), 1000);
            }
        } catch (error) {
            console.error('Error checking upload status:', error);
        }
    };

    const handleOptionToggle = (value: string): void => {
        const isSelected = selectedOptions.includes(value);
        if (isSelected) {
            setSelectedOptions(selectedOptions.filter(option => option !== value));
        } else {
            setSelectedOptions([...selectedOptions, value]);
        }
    };

    const isFormValid = url.length !== 0 || files.length > 0;

    const handleLogoClick = () => {
        window.location.href = '/search';
    };

    return (
        <Box>
            <Flex
                alignItems="center"
                justifyContent="space-between"
                mb={7}
                p={4}
                bg="gray.100"
                borderRadius="md"
                boxShadow="md"
            >
                <Image
                    src={logo}
                    alt=""
                    cursor="pointer"
                    onClick={handleLogoClick}
                />

                <Box justifyContent="center" ml={-60}>
                    <ClockBar />
                </Box>

                <Button
                    as="a"
                    href='/search'
                    role="button"
                    bg="#414042"
                    color="white"
                    p={3}
                    borderRadius="md"
                    boxShadow="md"
                    _hover={{ bg: "#E6E7E8", color: "#282c34", boxShadow: "lg", transform: "scale(1.05)" }}
                    _focus={{ boxShadow: "outline" }}
                >
                    BACK
                </Button>
            </Flex>

            <Box className="wrapper" p={4}>
                <Flex justifyContent="center" mb={4} gap={4}>
                    <Button
                        onClick={() => handleButtonClick('file')}
                        bg="#161A49"
                        color="white"
                        colorScheme="teal"
                        variant="solid"
                        _hover={{ bg: "#E6E7E8", color: "black", boxShadow: "lg", transform: "scale(1.05)" }}
                        _focus={{ boxShadow: "outline" }}
                    >
                        DRAG & DROP
                    </Button>
                    <Button
                        onClick={() => handleButtonClick('url')}
                        bg="#161A49"
                        color="white"
                        variant="solid"
                        _hover={{ bg: "#E6E7E8", color: "black", boxShadow: "lg", transform: "scale(1.05)" }}
                        _focus={{ boxShadow: "outline" }}
                    >
                        URL
                    </Button>
                </Flex>

                <Box
                    className='input'
                    onDrop={handleDrop}
                    onDragOver={(event) => event.preventDefault()}
                    p={4}
                    borderWidth={1}
                    borderRadius="md"
                    borderColor="gray.300"
                    bg="gray.50"
                >
                    {inputType === 'file' ? (
                        <Box p={5} borderWidth={1} borderRadius="md" borderColor="gray.300" bg="gray.50" textAlign="center" mb={4}>
                            <Text fontWeight="bold" mb={4}>Drag and drop your files here</Text>
                            <Text mb={4}>-or-</Text>

                            <Input
                                type='file'
                                onChange={handleFileChange}
                                multiple
                                id="file-upload"
                                display="none"
                            />

                            <label htmlFor="file-upload">
                                <Box
                                    as="span"
                                    p={2}
                                    borderWidth={1}
                                    borderRadius="md"
                                    borderColor="gray.300"
                                    bg="#161A49"
                                    color="white"
                                    cursor="pointer"
                                    _hover={{ bg: "#E6E7E8", color: "#161A49", transform: "scale(1.05)" }}
                                >
                                    Choose Files
                                </Box>
                            </label>
                        </Box>
                    ) : (
                        <>
                            <Textarea
                                placeholder="Insert URLs (separated by commas or new lines)"
                                value={url.join('\n')}
                                onChange={handleInputChange}
                                rows={4}
                                mb={2}
                            />
                            {isPasswordEnabled && (
                                <input
                                    type="password"
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    style={{ display: 'block', marginTop: '10px' }}
                                />
                            )}
                        </>
                    )}
                </Box>

                {files.length > 0 && (
                    <Box className="file-preview" mt={4} p={4} borderWidth={1} borderRadius="md" borderColor="gray.300" bg="gray.50">
                        <Text fontWeight="bold" mb={2}>Selected Files:</Text>
                        <Stack spacing={2}>
                            {files.map((file, index) => (
                                <Flex key={index} justifyContent="space-between" alignItems="center">
                                    <Text>{file.name}</Text>
                                    <Button
                                        onClick={() => handleRemoveFile(index)}
                                        colorScheme="red"
                                        size="md"
                                        _hover={{ bg: "#962324", color: "white", transform: "scale(1.05)" }}
                                        _focus={{ boxShadow: "outline" }}
                                    >
                                        Remove
                                    </Button>
                                </Flex>
                            ))}
                        </Stack>
                    </Box>
                )}

                {errorMessage && <Text color="#EE312F" mt={3}>{errorMessage}</Text>}

                <Flex justifyContent="center" mt={4}>
                    <ChakraButton
                        bg="#161A49"
                        color="white"
                        variant="solid"
                        _hover={{ bg: "#E6E7E8", color: "black", boxShadow: "lg", transform: "scale(1.05)" }}
                        _focus={{ boxShadow: "outline" }}
                        disabled={!isFormValid}
                        onClick={handleApply}
                    >
                        APPLY
                    </ChakraButton>

                    <ChakraButton
                        ml={4}
                        bg="#161A49"
                        color="white"
                        variant="solid"
                        _hover={{ bg: "#E6E7E8", color: "black", boxShadow: "lg", transform: "scale(1.05)" }}
                        _focus={{ boxShadow: "outline" }}
                        onClick={() => navigate('/file-upload')}
                    >
                        View Progress
                    </ChakraButton>
                </Flex>

                {isLoading && <Text>Please wait, loading...</Text>}
            </Box>
        </Box>
    );
};

export default Upload;
